import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';
import { of } from 'rxjs';
import { map, catchError, take } from 'rxjs/operators';
import { CURRENT_USER } from '../../shared/tokens/current-user.token';
import { UserService } from '@nrwl/rx-service-user';
import { AuthService } from '@nrwl/rx-service-auth';
import { Roles } from '@nrwl/rx-models';

const checkAccess = (user: any): boolean => {
  if (!user) return false;

  // Check admin permission
  const isAdmin = user.role === Roles.SuperAdmin || user.role === Roles.Admin;

  if (!isAdmin) return false;

  // Check EMR integration
  return String(user?.clinic?.emr_integration ?? '').toLowerCase() !== 'ennoview';
};

export const aiDashboardCanMatchGuard: CanMatchFn = () => {
  const currentUser = inject(CURRENT_USER);
  const user = currentUser();

  if (user) {
    return of(checkAccess(user));
  }

  const userService = inject(UserService);
  const authService = inject(AuthService);
  const userId = authService.getUserId();

  if (!userId) {
    return of(false);
  }

  return userService.getUserProfile({ payload: userId }).pipe(
    map((response: any) => checkAccess(response)),
    catchError(() => of(false)),
    take(1),
  );
};
